import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalGenericoModel } from "src/app/shared/models/modal.model";

@Component({
  selector: "app-modal-confirmar-eliminar-depositario",
  templateUrl: "./modal-confirmar-eliminar-depositario.component.html",
  styleUrls: ["./modal-confirmar-eliminar-depositario.component.scss"],
})
export class ModalConfirmarEliminarDepositarioComponent implements OnInit {
  @Input()
  modalGenerico: ModalGenericoModel;

  constructor(
    public formBuilder: FormBuilder,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.modalGenerico = {
      titulo: "",
    };
  }

  dismiss(): void {
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
  }

  sendForm(): void {
    if (this.activeModal) {
      this.activeModal.close();
    }
  }
}
